import { Button, Flex, useColorModeValue } from "@chakra-ui/react";
import router from "next/router";
const APP_HOST =
  `${process.env.NEXT_PUBLIC_USER_APP_HOST}/assets` ||
  "https://app.moongate.id/assets";

const _t = (key?: string) => key || "";

const CheckoutSuccessButtons = ({
  redirectToAppText = "See my NFT",
  redirectToEventText = "Back to Event",
}: {
  redirectToAppText?: string;
  redirectToEventText?: string;
}) => {
  return (
    <Flex marginTop={8} gap={6}>
      <Button
        variant="gradient"
        textTransform="capitalize"
        onClick={() => {
          window.location.href = `${APP_HOST}`;
        }}
        backgroundColor="#146588"
      >
        {_t(redirectToAppText)}
      </Button>
      <Button
        variant="outline"
        onClick={() =>
          router.push(`${window.location.href.replace(/\/checkout.+/, "")}`)
        }
        color={useColorModeValue("", "white")}
        textTransform="capitalize"
      >
        {_t(redirectToEventText)}
      </Button>
    </Flex>
  );
};

export default CheckoutSuccessButtons;
